import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import PropTypes from "prop-types";
import BoxSkeleton from "../utilities/BoxSkeleton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoxOpen, faSearch } from "@fortawesome/free-solid-svg-icons";
import { tr } from "../../i18n";
import "../../assets/css/dataTable.css";

const DataTableComponent = ({ columns, fetchData }) => {
  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [filterText, setFilterText] = useState("");

  const modifiedColumns = columns.map((col) => ({
    ...col,
    width: col.width || "auto", // Gunakan width jika ada, jika tidak, pakai auto
  }));

  useEffect(() => {
    loadData(page, perPage, filterText);
  }, [page, perPage, filterText, fetchData]);

  const loadData = async (page, perPage, search) => {
    setLoading(true);
    try {
      const response = await fetchData({ page, perPage, search });
      setData(response.data);
      setTotalRows(response.total);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (page) => {
    setPage(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    setPage(page);
  };

  // Custom Styling untuk Resizable Columns
  const customStyles = {
    table: {
      style: {
        backgroundColor: "#ffffff",
        borderRadius: "16px",
      },
    },
    headRow: {
      style: {
        minHeight: "48px",
        backgroundColor: "#f0f5fd",
        borderBottom: "1px solid #d9e4f5",
        fontWeight: 700,
        color: "#29486b",
      },
    },
    headCells: {
      style: {
        fontSize: "13px",
        letterSpacing: "0.2px",
      },
    },
    rows: {
      style: {
        minHeight: "58px",
        borderBottom: "1px solid #edf2fa",
        color: "#243b53",
      },
    },
    cells: {
      style: {
        padding: "12px 14px",
        wordBreak: "normal",
        overflowWrap: "anywhere",
        whiteSpace: "normal",
      },
    },
    pagination: {
      style: {
        minHeight: "56px",
        borderTop: "1px solid #edf2fa",
        color: "#486581",
      },
    },
  };

  return (
    <div className="table-container datatable-surface">
      <div className="table-header table-header-modern">
        <div className="search-container">
          <FontAwesomeIcon icon={faSearch} className="search-icon" />
          <input
            type="text"
            placeholder={tr("shared:search")}
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
            className="search-input"
          />
        </div>
      </div>
      <DataTable
        columns={modifiedColumns}
        data={data}
        progressPending={loading}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        onChangePage={handlePageChange}
        onChangeRowsPerPage={handlePerRowsChange}
        highlightOnHover
        customStyles={customStyles}
        noDataComponent={
          <div className="datatable-empty-state">
            <div className="datatable-empty-icon-wrap">
              <FontAwesomeIcon
                icon={faBoxOpen}
                className="datatable-empty-icon"
              />
            </div>
            <div className="datatable-empty-title">{tr("shared:no_records_found")}</div>
            <div className="datatable-empty-subtitle">
              {tr("shared:try_adjusting_search_keywords_or_add")}
            </div>
          </div>
        }
        progressComponent={<BoxSkeleton count="6" size="12" height="30px" />}
      />
    </div>
  );
};

DataTableComponent.propTypes = {
  columns: PropTypes.array.isRequired,
  fetchData: PropTypes.func.isRequired,
};

export default DataTableComponent;
